'use strict';

import './routes';